var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAddFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.5C7.89543 1.5 7 2.39543 7 3.5V5.5C5.34315 5.5 4 6.84315 4 8.5V21H2C1.44772 21 1 21.4477 1 22C1 22.5523 1.44772 23 2 23H13C13.5523 23 14 22.5523 14 22C14 21.4477 13.5523 21 13 21H6V8.5C6 7.94772 6.44772 7.5 7 7.5H13.5C14.0523 7.5 14.5 7.05228 14.5 6.5C14.5 5.94772 14.0523 5.5 13.5 5.5H9V3.5H15.5V5.5C15.5 6.60457 16.3954 7.5 17.5 7.5H18V12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12V7.5C20 6.39543 19.1046 5.5 18 5.5H17.5V3.5C17.5 2.39543 16.6046 1.5 15.5 1.5H9ZM8.5 11.5C7.94772 11.5 7.5 11.9477 7.5 12.5C7.5 13.0523 7.94772 13.5 8.5 13.5H9.5C10.0523 13.5 10.5 13.0523 10.5 12.5C10.5 11.9477 10.0523 11.5 9.5 11.5H8.5ZM14.5 11.5C13.9477 11.5 13.5 11.9477 13.5 12.5C13.5 13.0523 13.9477 13.5 14.5 13.5H15.5C16.0523 13.5 16.5 13.0523 16.5 12.5C16.5 11.9477 16.0523 11.5 15.5 11.5H14.5ZM8.5 16C7.94772 16 7.5 16.4477 7.5 17C7.5 17.5523 7.94772 18 8.5 18H9.5C10.0523 18 10.5 17.5523 10.5 17C10.5 16.4477 10.0523 16 9.5 16H8.5ZM20 16C20 15.4477 19.5523 15 19 15C18.4477 15 18 15.4477 18 16V18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H18V22C18 22.5523 18.4477 23 19 23C19.5523 23 20 22.5523 20 22V20H22C22.5523 20 23 19.5523 23 19C23 18.4477 22.5523 18 22 18H20V16Z",
    fill: "#292F4D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddFacility);
export default __webpack_public_path__ + "static/media/ic_add-facility.f8e0d896ec07e756813e0583d9663bb1.svg";
export { ForwardRef as ReactComponent };